import { getReportMacros } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
/**
 * The one query for the user's macros (system + personal), shared by the
 * report editors, the settings screens and every other field that expands
 * macros. Prefetch with the same options so the cache entry is shared.
 */
export const reportMacrosQuery = {
    queryKey: ['report-macros'],
    // Lazy reference: tests that mock '@/lib/api' without this export still load.
    queryFn: () => getReportMacros(),
    staleTime: 5 * 60_000,
};
export function useReportMacros() {
    const { data, isLoading, isError } = useQuery(reportMacrosQuery);
    return { macros: data ?? [], isLoading, isError };
}
